export const newPostAction = "j_a";
export const newYammerPostAction = "k_a";
export default {newPostAction,newYammerPostAction};